import { render, staticRenderFns } from "./ClockItem.vue?vue&type=template&id=5466d8d5&scoped=true&"
import script from "./ClockItem.vue?vue&type=script&lang=js&"
export * from "./ClockItem.vue?vue&type=script&lang=js&"
import style0 from "./ClockItem.vue?vue&type=style&index=0&id=5466d8d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5466d8d5",
  null
  
)

export default component.exports